import React, { RefObject } from 'react';
import { TextArea } from '../TextArea/TextArea';
import styles from './TextAreaCount.module.css';

export interface TextareaCountProps {
  hasClearButton?: boolean;
  isLoading?: boolean;
  onClearClick?: () => void;
  onTextAreaChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  value: string;
  customCSS?: string;
  lengthLimit: number;
  labelText: string;
  textareaRef?: RefObject<HTMLTextAreaElement>;
  dataTestId?: string;
  rows?: number;
}

export default function TextareaCount({
  lengthLimit,
  labelText,
  value,
  ...textareaProps
}: TextareaCountProps) {
  function getLimitColor() {
    const ratio = value.length / lengthLimit;
    if (ratio > 0.75) return { color: '#FF0000' };
    else if (ratio > 0.5) return { color: '#FFA500' };
    return { color: '#008000' };
  }

  return (
    <div className={styles.textareaCount}>
      <label className={styles.label}>
        {labelText}{' '}
        <span
          style={{ ...getLimitColor(), fontSize: '11px' }}
        >{`${value.length}/${lengthLimit}`}</span>
      </label>
      <TextArea {...textareaProps} value={value} lengthLimit={lengthLimit} />
    </div>
  );
}
